import React from "react";
import { motion } from "framer-motion";
import { fadeUp, useMotionPrefs, withMotionPrefs } from "@/lib/motion";

export default function MotionCard({ children, className = "", ...props }) {
  const { isReduced } = useMotionPrefs();
  const variants = withMotionPrefs(fadeUp, isReduced);

  return (
    <motion.div
      className={className}
      variants={variants}
      initial="hidden"
      animate="show"
      {...props}
    >
      {children}
    </motion.div>
  );
}
